import React, { useState, useEffect, Fragment } from 'react';
import { TextField, Box, Button, CircularProgress, Typography, Card, CardActions, CardContent, CardHeader, DateTime } from '@mui/material';

import { useNotify } from 'react-admin'
import client from '../common/client';
import Help from '../component/Help'

const ProjectBackendResourceDistribution = props => {
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);

    const distributeNow = (e) => {
        setLoading(true)
        client.request_get(`/api/resource/backend/deploy/project/${props.project.id}`).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Distrubute Success`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    useEffect(() => {
    }, [props.project])

    return (
        <Card >
            <CardHeader
                title="Entity Distrubution"
                action={
                    <Help />
                }
            />
            <CardContent>
                <Box>
                    Backend Entity to Git Repository
                    Menu, Icon, property, etc...
                </Box>
            </CardContent>
            <CardActions>
                <Box m={1}>
                    <Button variant="contained" color="primary" startIcon={loading && <CircularProgress size={24} />} onClick={distributeNow} disabled={loading}>
                        Resource To Git</Button>
                </Box>
            </CardActions>
        </Card>
    );
};

export default ProjectBackendResourceDistribution;
